import { BaseLayoutFactory } from "../global/base-layout-factory";
import { GovernmentProjectDetailProvider } from "./context/government-project-detail-context";
import { GovernmentProjectDetailComponent } from "./government-project-detail-component";

export function GovernmentProjectDetailFactory() {
    return (
        <BaseLayoutFactory>
            <GovernmentProjectDetailProvider>
                <GovernmentProjectDetailComponent />
            </GovernmentProjectDetailProvider>
        </BaseLayoutFactory>
    );
}
